<template>
    <div>
        <breadcrumbs />
        <div class="mt-4" />
        <feedback-list />
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import FeedbackList from '@/components/account/feedback/FeedbackList.vue'

    @Component({
        components: {
            FeedbackList,
            Breadcrumbs,
        },
    })
    export class FeedbackPage extends Vue {}

    export default FeedbackPage
</script>
